<template>
  <b-modal id="search-modal"
    hide-header
    hide-footer
    data-name="search-modal">
    <jump-search :show-tip="false"
      @search-jump-found="closeModal" />
  </b-modal>
</template>

<script>
import JumpSearch from './JumpSearch'

export default {
  name: 'SearchModal',

  components: {
    'jump-search': JumpSearch,
  },

  data() {
    return {
      // show: false,
    }
  },

  beforeDestroy() {
    document.removeEventListener('keyup', this.handleKeys)
  },

  mounted() {
    document.addEventListener('keyup', this.handleKeys)
  },

  methods: {
    // Listen for the character 't'
    handleKeys(evt) {
      if (evt.keyCode === 84 && evt.target.nodeName !== 'INPUT' && evt.target.nodeName !== 'TEXTAREA') {
        // this.show = true;
        this.$bvModal.show('search-modal')
        setTimeout(() => {
          const inputRef = document.querySelector('#search-modal input')
          inputRef.value = ''
          inputRef.focus()
        }, 1)
      }
    },
    closeModal() {
      this.$bvModal.hide('search-modal')
      // this.show = false;
    },
  },
}
</script>
